export default __webpack_public_path__ + "static/redfam-ce74fc0df5150a1a751ea347478ef5e4.png";